import axios from 'axios';
import { API_BASE_URL } from './config';

export const loginApi = (username, password) =>
  axios.post(`${API_BASE_URL}/token/`, { username, password });

export const registerApi = (username, password) =>
  axios.post(`${API_BASE_URL}/register/`, { username, password });
